import { Component, Inject, OnInit } from "@angular/core";
import { Firestore } from "@angular/fire/firestore";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "@core/auth.service";
import { MySnackBarService } from "@core/my-snack-bar.service";
import { TranslateService } from "@ngx-translate/core";
import { JackpotTriggersService } from "src/app/services/jackpot-triggers.service";
import { LuckyNumberService } from "src/app/services/lucky-number.service";
import { SelectedLuckyNumbersLockedComponent } from "../selected-lucky-numbers-locked/selected-lucky-numbers-locked.component";
@Component({
  selector: "app-confirm-selected-lucky-numbers",
  templateUrl: "./confirm-selected-lucky-numbers.component.html",
  styleUrls: ["./confirm-selected-lucky-numbers.component.scss"],
})
export class ConfirmSelectedLuckyNumbersComponent implements OnInit {
  syndicateId: any;
  balanceDetails: any;
  remainingCount: any;
  isConfirm: boolean = false;
  ticketDetails: any;
  selectedLuckyNumbers: any;
  translatedToastMsg: any;
  selectedLanguage: string = "en";
  languageCode: string = "en";
  confirmPopupTranslatedData: any;
  changeMyNumber: string;
  confirmButton: string;
  description: string;
  title: string;
  public userId: string;
  constructor(
    private firestore: Firestore,
    private matDialog: MatDialog,
    private matDialogRef: MatDialogRef<ConfirmSelectedLuckyNumbersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private luckyNumberService: LuckyNumberService,
    private snackService: MySnackBarService,
    public translate: TranslateService,
    private authService: AuthService,
    private jackpotTriggerService: JackpotTriggersService,
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l;
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );

    this.authService?.getConstantsMsg$?.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    });
    this.matDialogRef.disableClose = true;
  }

  async ngOnInit() {
    await this.authService.getUid("ConfirmSelectedLuckyNumbersComponent").then((uid) => {
      this.userId = uid;
    })
    this.syndicateId = this.data?.syndicateId;
    this.ticketDetails = this.data?.ticketDetails;
    this.selectedLuckyNumbers = this.data?.selectedLuckyNumbers;
    this.balanceDetails = this.data?.balanceDetails;

    this.authService?.userDetails$?.subscribe((user: any) => {
      this.languageCode = user?.language_code ? user?.language_code : "en";
      this.jackpotTriggerService?.getTranslatedData(this.languageCode)?.subscribe(
        (data) => {
          this.confirmPopupTranslatedData = data?.["confirm-selected-lucky-numbers"];
          this.changeMyNumber = this.confirmPopupTranslatedData?.change_my_number;
          this.confirmButton = this.confirmPopupTranslatedData?.confirm_button;
          this.description = this.confirmPopupTranslatedData?.description;
          this.title = this.confirmPopupTranslatedData?.title;
        },
        (err) => {
          return err;
        }
      );
    });
  }

  async openLuckyNumbersLockedPopup() {
    if (this.isConfirm) {
      return;
    }
    try {
      this.isConfirm = true;
      await this.luckyNumberService.getSelectedNumbersData(
        this.syndicateId,
        this.selectedLuckyNumbers,
        this.ticketDetails
      );
      this.luckyNumberService.updateCurrentBalance(this.balanceDetails);

      if (this.userId) {
        try {
          const path_id = "DbU2pkEiHAXMH23hKINJ";
          const doc_data = { is_selected_numbers: true };
          const method = "update";
          const dv = { docId: this.syndicateId };
          await this.authService.getV2CloudFunction("updatefirestoredoc", {
            path_id,
            doc_data,
            dv,
            method
          }).subscribe({
            error: (error) => {
              console.error("Error updating document:", error);
              return error;
            }
          });
        } catch (error) {
          return error;
        }
      }

      // Close only this dialog
      this.matDialogRef.close({ success: true });

      // Open success dialog
      const modal = this.matDialog.open(SelectedLuckyNumbersLockedComponent, {
        panelClass: "lucky-number-popup",
        minHeight: "60vh",
        width: "85vw",
        data: this.userId,
        disableClose: true
      });

      modal.afterClosed().subscribe(
        () => {
          this.authService.getConstantsMsg("1028").then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: "Your Lucky Numbers applied successfully!!!",
                line_2: "",
              },
              style: {
                icon: "tick circle success.png",
                type: "Success",
              }
            };
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          }).catch((error) => {
            return error;
          });
        }
      );

      this.luckyNumberService.selectedLnSaved.next(true);

    } catch (error) {
      // Show error message
      this.authService.getConstantsMsg("1015").then((translatedMsg) => {
        const defaultMsg = {
          message: {
            line_1: "Something went wrong! Please try again.",
            line_2: "",
          },
          style: {
            icon: "tick circle error.svg",
            type: "Error",
          }
        };
        this.authService.showToastMessage(translatedMsg, defaultMsg);
      }).catch((error) => {
        return error;
      });

      // Ensure we can retry
      this.isConfirm = false;
      return false;
    } finally {
      // Always reset flag after operation completes
      setTimeout(() => {
        this.isConfirm = false;
      }, 1000);
    }
  }

  async openLuckyNumbersLockedPopupOld() {
    this.isConfirm = true;
    // await this.luckyNumberService.processSelectedLN(this.syndicateDetails);
    await this.luckyNumberService.saveSelectedLuckyNumber(
      this.syndicateId,
      this.ticketDetails,
      this.selectedLuckyNumbers
    );
    this.matDialog.closeAll(); // close confirm popup

    const modal = this.matDialog.open(SelectedLuckyNumbersLockedComponent, {
      panelClass: "lucky-number-popup",
      minHeight: "60vh",
      width: "85vw",
      data: this.userId,
    });
    this.luckyNumberService.updateCurrentBalance(this.balanceDetails);
    this.luckyNumberService.selectedLnSaved.next(true);
  }

  closePopup() {
    this.matDialog.closeAll();
  }
}
